export default __webpack_public_path__ + "static/mp-4414d04a68288d30fcd789808dfb0eea.jpg";